"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERRORS = void 0;
const ErrorDescriptor_1 = require("./ErrorDescriptor");
const formatCodeFactory_1 = require("./formatCodeFactory");
const formatCode = (0, formatCodeFactory_1.formatCodeFactory)('E_PALLAD_ERRORS_%c');
// Needed to solve circular reference problem where ErrorDescriptor is not yet defined here
function lazyInitialization(descriptorFactory) {
    let descriptor;
    function getDescriptor() {
        if (!descriptor) {
            descriptor = descriptorFactory();
        }
        return descriptor;
    }
    return Object.assign((...args) => {
        return getDescriptor().create(...args);
    }, {
        getCode() {
            return getDescriptor().code;
        }
    });
}
exports.ERRORS = {
    CODE_ALREADY_TAKEN: lazyInitialization(() => {
        return ErrorDescriptor_1.ErrorDescriptor.useMessageFormatter(formatCode(1), (code) => {
            return `Error code "${code}" is already registered`;
        });
    }),
    DOMAIN_IS_LOCKED: lazyInitialization(() => ErrorDescriptor_1.ErrorDescriptor.useDefaultMessage(formatCode(2), 'Domain is locked and no other error descriptors can be added')),
    ERROR_FROZEN: lazyInitialization(() => ErrorDescriptor_1.ErrorDescriptor.useDefaultMessage(formatCode(3), 'Cannot assign "code" property to frozen error object')),
    MISSING_PLACEHOLDER_IN_CODE_FORMAT: lazyInitialization(() => ErrorDescriptor_1.ErrorDescriptor.useMessageFormatter(formatCode(4), (format) => {
        return `Code placeholder "${formatCodeFactory_1.PLACEHOLDER_TOKEN}" is missing in format "${format}"`;
    })),
    INVALID_ERROR_DESCRIPTOR_UNDER_KEY: lazyInitialization(() => ErrorDescriptor_1.ErrorDescriptor.useMessageFormatter(formatCode(5), (key) => {
        return `Value under key "${key}" is not valid ErrorDescriptor`;
    }))
};
